import React from "react";
import { Card } from "reactstrap";
import { Icon } from "../../Component";

const StoreStatistics = ({data,isLoading}) => {
  return (
    <Card className="h-100">
      <div className="card-inner">
        <div className="card-title-group mb-2">
          <div className="card-title">
            <h6 className="title">Statistics</h6>
          </div>
        </div>
        <ul className="nk-store-statistics">
         {data?.map((item,index)=>(
           <li className="item" key={index}>
            <div className="info">
              <div className="title">{item?.title}</div>
              <div className="count">{item?.count}</div>
            </div>
            <Icon name={item?.icon} className={`${item?.class}`}></Icon>
          </li>
         ))}
          {/* <li className="item">
            <div className="info">
              <div className="title">Customers</div>
              <div className="count">2,327</div>
            </div>
            <Icon name="users" className="bg-info-dim"></Icon>
          </li>
          <li className="item">
            <div className="info">
              <div className="title">Products</div>
              <div className="count">674</div>
            </div>
            <Icon name="box" className="bg-pink-dim"></Icon>
          </li>
          <li className="item">
            <div className="info">
              <div className="title">Categories</div>
              <div className="count">68</div>
            </div>
            <Icon name="server" className="bg-purple-dim"></Icon>
          </li> */}
        </ul>
      </div>
    </Card>
  );
};
export default StoreStatistics;
